import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import backgroundImage from '../assets/Garbh Samarthya/vectors-11.png';
import './CourseInfoSection.css';

const CourseInfoSection = ({
  title,
  content,
  className = '',
  ...rest
}) => {
  // Apply background image for introduction variant
  const innerStyle = className.includes('introduction') ? {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain'
  } : {};

  return (
    <section className={`course-info-section ${className}`.trim()} {...rest}>
      <div className="course-info-section__inner" style={innerStyle}>
        <h2 className="course-info-section__title">{title}</h2>
        <div className="course-info-section__content">
          {content ? ReactHtmlParser(content) : <p>Content will be available soon.</p>}
        </div>
      </div>
    </section>
  );
};

CourseInfoSection.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  className: PropTypes.string,
};

CourseInfoSection.defaultProps = {
  content: '',
  className: '',
};

export default CourseInfoSection;

